import { createContext } from 'react';
var RowContext = createContext({});
export default RowContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/RowContext.js
// module id = 400
// module chunks = 0